import CustomSegment from '@/components/CustomSegment';
import PageTitle from '@/components/PageTitle';
import { useSegment } from '@/hooks/useSegment';
import DashboardLayout from '@/layouts/DashboardLayout';
import type { SegmentedType } from '@/types/global.types';
import Filters from './_components/Filters';
import Leave from './Leave';
import OverTime from './OverTime';

export type PolicySegmentType =
  | 'leave'
  | 'expense'
  | 'overtime'
  | 'recruitment'
  | 'shift';

const Policies = () => {
  const { segment, setSegment } = useSegment<PolicySegmentType>(
    'control-panel-policies',
    'overtime',
    false,
  );
  const SEGMENT_CONFIG: SegmentedType<PolicySegmentType>[] = [
    {
      value: 'overtime',
      label: 'Overtime',
      view: <OverTime />,
    },
    {
      value: 'leave',
      label: 'Leave',
      view: <Leave />,
    },
    // {
    //   value: 'shift',
    //   label: 'Shift',
    //   view: <Shift />,
    // },
    // {
    //   value: 'recruitment',
    //   label: 'Recruitment',
    //   view: <Recruitment />,
    // },
    // {
    //   value: 'expense',
    //   label: 'Expense',
    //   view: <Expense />,
    // },
  ];
  const currentSegment = SEGMENT_CONFIG.find((s) => s.value === segment);

  return (
    <DashboardLayout title="Policies">
      <PageTitle
        classNames={{ root: 'items-start' }}
        title="Policies"
        items={[
          { title: 'Dashboard', path: '/admin/control-panel/dashboard' },
          { title: currentSegment?.label },
        ]}
      >
        <Filters type={segment} />
      </PageTitle>
      <CustomSegment
        config={SEGMENT_CONFIG}
        selected={segment}
        onChange={setSegment}
      />
      <div className="mt-5">{currentSegment?.view}</div>
    </DashboardLayout>
  );
};

export default Policies;
